import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import emailjs from "emailjs-com";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css"; 
import { toast } from "react-toastify";
const BookingForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    email: "",
    date: null,
    procedure: "",
    requirements: "",
  });

  const [responseMessage, setResponseMessage] = useState("");
  const [loading, setLoading] = useState(false);

  // Handle change for all input fields
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // Handle date change
  const handleDateChange = (date) => {
    setFormData({ ...formData, date });
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    const serviceId = "service_y2wiyv9";
    const templateId = "template_vdgakx6";
    const userId = "gHJShnDhyA9tSUzLk";

    emailjs
      .send(serviceId, templateId, formData, userId)
      .then(
        (result) => {
          setResponseMessage("Your appointment request has been submitted!");
          setFormData({
            name: "",
            mobile: "",
            email: "",
            procedure: "",
            date: null,
            requirements: "",
          });
          toast.success("Your appointment request has been submitted!")
        },
        (error) => {
          setResponseMessage("Failed to submit the appointment request. Please try again.");
          toast.error("Failed to submit the appointment request. Please try again.")
        }
      )
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <div>
      <div
        className="appointment-sec bg-top-center space background-image"
        id="contact-sec"
        style={{
          backgroundImage:
            'url("https://img.freepik.com/premium-photo/workers-inspecting-assembly-line-quality-control_1265500-106036.jpg?w=900")',
          position: "relative",
        }}
      >
        <div className="overlay overlay-bold"></div>
        <Container>
          <Row>
            <div className="col-md-6">
              <div
                className="title-area mb-25 text-center text-lg-start"
                //   style={{ padding: "0px 50px", maxWidth: "700px" }}
              >
                <span className="sub-title text-white">
                  Make An Appointment
                </span>
                <h2 className="sec-title text-white">
                  Unveil Your True Potential with Our Expert Plastic Surgery
                  Services at Surgery Saathi!
                </h2>
              </div>
              <div className="appointment-work text-center text-lg-start">
                <h4 className="work-title">CLINIC TIMINGS:</h4>
                {/* <p>
                              we are dedicated to delivering exceptional results and ensuring your
                              nails make a bold and beautiful statement.
                          </p> */}
                <ul className="working-list">
                  <li>
                    Monday - Sunday<span>9:30am - 6:30pm</span>
                  </li>
                  {/* <li>
                    Sunday<span>Closed</span>
                  </li> */}
                </ul>
                <h4 className="work-title">Address</h4>
                <h5 className="booking-form-head5">
                  Sec 43 Gurgaon, Delhi Cantt, Indirapuram Ghaziabad, Noida
                </h5>
                <h5 className="booking-form-head5">Phone: +918882852726</h5>
                <h5 className="booking-form-head5">
                  E-mail: info@surgerysaathi.com
                </h5>
              </div>
            </div>
            <div
              className="col-lg-6"
              style={{ position: "relative", zIndex: "6" }}
            >
              <form
                onSubmit={handleSubmit}
                className="appointment-quote-form wow fadeInUp"
                style={{ visibility: "visible", animationName: "fadeInUp" }}
              >
                <div className="row">
                  <Col className="col-md-6 form-group" md={6} sm={6} xs={6}>
                    <i className="fa-sharp fa-light fa-user" />{" "}
                    <input
                      type="text"
                      placeholder="Name"
                      className="form-control"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                    />
                  </Col>
                  <Col className="col-md-6 form-group" md={6} sm={6} xs={6}>
                    <i className="fa-sharp fa-light fa-user" />{" "}
                    <input
                      type="number"
                      placeholder="Phone Number"
                      className="form-control"
                      name="mobile"
                      value={formData.mobile}
                      onChange={handleChange}
                      required
                    />
                  </Col>
                  <Col className="col-md-6 form-group" md={6} sm={6} xs={6}>
                    <i className="fa-light fa-envelope-open" />{" "}
                    <DatePicker
                      selected={formData.date}
                      onChange={handleDateChange}
                      className="form-control"
                      placeholderText="Select Date"
                      dateFormat="MM/dd/yyyy"
                      required
                    />
                  </Col>
                  <Col className="col-md-6 form-group" md={6} sm={6} xs={6}>
                    <i className="fa-light fa-phone" />{" "}
                    <select
                      name="procedure"
                      value={formData.procedure}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Select Category</option>
                      <option value="Rhinoplasty">Rhinoplasty</option>
                      <option value="Septoplasty">Septoplasty</option>
                      <option value="Lipoma">Lipoma</option>
                      <option value="Gynecomastia">Gynecomastia</option>
                      <option value="Ophthalmology">Ophthalmology</option>
                      <option value="Lasik surgery">Lasik surgery</option>
                      <option value="Cataract surgery">Cataract surgery</option>
                      <option value="ICL (implantable collamer lens) treatment">
                        ICL (implantable collamer lens) treatment
                      </option>
                      <option value="Glaucoma treatment">
                        Glaucoma treatment
                      </option>
                      <option value="Corneal surgery">Corneal surgery</option>
                      <option value="Pediatrics Eye care">
                        Pediatrics Eye care
                      </option>
                      <option value="RLE (Refractive Lens Exchange)">
                        RLE (Refractive Lens Exchange)
                      </option>
                      <option value="Hair transplant">Hair transplant</option>
                      <option value="Skin">Skin</option>
                      <option value="Face">Face</option>
                      <option value="Body">Body</option>
                      <option value="Breast (implant)">Breast (implant)</option>
                      <option value="Gynaecology">Gynaecology</option>
                      <option value="Liposuction">Liposuction</option>
                    </select>
                  </Col>
                  <Col className="form-group col-12" md={12} sm={6} xs={6}>
                    <textarea
                      className="time-pick form-control text-area-btnnn"
                      name="requirements"
                      placeholder="Select Message"
                      rows={3}
                      value={formData.requirements}
                      onChange={handleChange}
                      style={{ height: "100px" }}
                      required
                    />
                  </Col>

                  <div className="btn-group justify-content-center justify-content-xl-end">
                    <button
                      disabled={loading}
                      className="th-btn style3 fw-btn"
                      style={{ padding: "15px", color: "#000" }}
                    >
                      {loading ? "Submitting..." : "Make An Appointment"}{" "}
                      <i className="fa-solid fa-arrow-right ms-2" />
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </Row>
        </Container>
      </div>
    </div>
    //   </div>
  );
};

export default BookingForm;
